export const columns = ({ sorted }) => {
    return [
      {
        title: "",
        dataIndex: "action",
        key: "action",
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
        sortOrder: sorted.columnKey === "name" && sorted.order,
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        sorter: (a, b) => (a.email || "").localeCompare(b.email || ""),
        sortOrder: sorted.columnKey === "email" && sorted.order,
      },
      {
        title: "Created On",
        dataIndex: "createdAt",
        key: "createdAt",
        sorter: (a, b) => a.createdAt - b.createdAt,
        sortOrder: sorted.columnKey === "createdAt" && sorted.order,
      },
      {
        title: "Is Verified",
        dataIndex: "isVerified",
        key: "isVerified",
        sorter: (a, b) => a.isVerified - b.isVerified,
        sortOrder: sorted.columnKey === "isVerified" && sorted.order,
      },
      {
        title: "Is Premium",
        dataIndex: "isPremium",
        key: "isPremium",
        sorter: (a, b) => a.isPremium - b.isPremium,
        sortOrder: sorted.columnKey === "isPremium" && sorted.order,
      },
      {
        title: "Premium Expiry",
        dataIndex: "membershipExpiry",
        key: "membershipExpiry",
        sorter: (a, b) => a.membershipExpiry - b.membershipExpiry,
        sortOrder: sorted.columnKey === "membershipExpiry" && sorted.order,
      },
    ];
  };